import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertMessageService, LoadingService, Page } from '@serpro/ngx-suite-rfb';
import { EstiloSegmento } from 'src/app/shared/model/estilo-segmento.model';
import { EDICAO_TIPO_SEGMENTO, INCLUSAO_TIPO_SEGMENTO, TipoEdicao, VISUALIZACAO_TIPO_SEGMENTO } from 'src/app/shared/model/tipo-edicao.model';
import { TipoSegmento } from 'src/app/shared/model/tipo-segmento.model';
import { TipoSegmentoService } from 'src/app/shared/services/tipo-segmento.service';
import { EstadoGerirTipoSegmento } from 'src/app/shared/state/estado-gerir-tipo-segmento';
import { EstadoComponent } from 'src/app/shared/state/main/estado-component';

@Component({
    selector: 'app-gerir-tipos-segmento',
    templateUrl: './gerir-tipos-segmento.component.html',
    styleUrls: ['./gerir-tipos-segmento.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class GerirTiposSegmentoComponent extends EstadoComponent<EstadoGerirTipoSegmento> implements OnInit {

    @ViewChild('nomeInput') nomeInput: ElementRef;
    @ViewChild('siglaInput') siglaInput: ElementRef;

    tiposSegmento: TipoSegmento[];
    tiposOriginais: TipoSegmento[] = [];
    tiposOriginaisOrdenados: TipoSegmento[] = [];

    // Paginação
    pageSize = 100;
    currentPage: Page = { first: 0, last: this.pageSize, number: 1 };

    // Ordenação
    listaVazia: TipoSegmento[] = [];
    sortedBy: (boolean | undefined)[] = [undefined, undefined, undefined];
    sortedColumn: string[] = ['id', 'nome', 'sigla'];

    tipoSegmento: TipoSegmento;
    tipoSegmentoGlobal: TipoSegmento;
    tipoEdicao: TipoEdicao;
    readonly = false;
    exibirModalEstiloSegmento = false;

    constructor(
        private tipoSegmentoService: TipoSegmentoService,
        private alertMessageService: AlertMessageService,
        private loadingService: LoadingService
    ) {
        super(EstadoGerirTipoSegmento);
    }

    ngOnInit(): void {
        this.exibirModalEstiloSegmento = false;
        document.title = 'Gerir tipos de segmento';
        this.alertMessageService.dismissAll();
        this.loadingService.show();
        this.carregarTiposSegmento();
    }

    carregarTiposSegmento() {
        this.tipoSegmentoService.findAll().subscribe({
            next: retorno => {
                this.tiposOriginaisOrdenados = retorno;
                this.tiposOriginais = retorno;
                this.tiposSegmento = this.listaVazia.concat(this.tiposOriginaisOrdenados);
                this.tipoSegmentoGlobal = retorno[0];
                this.loadingService.hide();
            },
            error: () => this.loadingService.hide()
        });
    }

    sortByColuna(indice: number, asc: boolean) {
        this.resetSortedBy();
        this.sortedBy[indice] = asc;
        const lista = this.listaVazia.concat(this.tiposOriginais);
        if (asc != undefined) {
            lista.sort(TipoSegmento.getFunctionSortBy(this.sortedColumn[indice]));
            if (!asc) {
                lista.reverse();
            }
        }
        this.tiposOriginaisOrdenados = lista;
    }

    private resetSortedBy() {
        for (let i = 0; i < this.sortedBy.length; i++) {
            this.sortedBy[i] = undefined;
        }
    }

    filter() {
        let lista = this.listaVazia.concat(this.tiposSegmento);
        if (this.estado.filtroNome) {
            lista = lista.filter(t => t.nomeTipoSegmento.toLowerCase().indexOf(this.estado.filtroNome.toLowerCase()) >= 0);
        }
        if (this.estado.filtroSigla) {
            lista = lista.filter(t => t.siglaTipoSegmento.toLowerCase().indexOf(this.estado.filtroSigla.toLowerCase()) >= 0);
        }
        if (this.estado.indiceOrdenacao !== undefined) {
            this.resetSortedBy();
            this.sortedBy[this.estado.indiceOrdenacao] = this.estado.ascOrdenacao;
            if (this.estado.ascOrdenacao != undefined) {
                lista.sort(TipoSegmento.getFunctionSortBy(this.sortedColumn[this.estado.indiceOrdenacao]));
                if (!this.estado.ascOrdenacao) {
                    lista.reverse();
                }
            }
        }
        
        this.currentPage = { first: 0, last: this.pageSize, number: 0 };
        this.tiposOriginaisOrdenados = lista;
    }
    
    filterByNome(filter: string): void {
        this.estado.filtroNome = filter;
        this.filter();
    }

    filterBySigla(filter: string) {
        this.estado.filtroSigla = filter;
        this.filter();
    }

    subirParaTopoPagina() {
        window.scrollTo({left:0, top: 0, behavior: 'smooth'});
    }

    excluirTipoSegmento(tipo: TipoSegmento) {
        this.alertMessageService.dismissAll();
        if (tipo != null && tipo.idTipoSegmento != null && this.validarParaExcluir(tipo)) {
            this.loadingService.show();
            this.tipoSegmentoService.deleteTipoSegmento(tipo.idTipoSegmento).subscribe({
                next: () => {
                    this.alertMessageService.info('Sucesso', 'Tipo de segmento excluído com sucesso.');
                    this.carregarTiposSegmento();
                },
                error: () => this.loadingService.hide()
            });
        }
    }

    private validarParaExcluir(tipo: TipoSegmento): boolean {
        if (tipo.idTipoSegmento === 0) {
            this.alertMessageService.warn('Validação', 'O tipo de segmento ' + tipo.nomeTipoSegmento + ' não pode ser excluído.');
            return false;
        }
        return true;
    } 

    visualizarTipoSegmento(tipo: TipoSegmento) {
        this.alertMessageService.dismissAll();
        this.tipoEdicao = VISUALIZACAO_TIPO_SEGMENTO;
        this.tipoSegmento = tipo;
        this.readonly = true;
        this.exibirModalEstiloSegmento = true;
    }

    editarTipoSegmento(tipo: TipoSegmento) {
        this.alertMessageService.dismissAll();
        this.tipoEdicao = EDICAO_TIPO_SEGMENTO;
        this.tipoSegmento = {...tipo};
        this.readonly = false;
        this.exibirModalEstiloSegmento = true;
    }

    incluirNovoTipoSegmento() {
        this.alertMessageService.dismissAll();
        this.tipoEdicao = INCLUSAO_TIPO_SEGMENTO;
        this.tipoSegmento = this.criarNovoTipoSegmento();
        this.readonly = false;
        this.exibirModalEstiloSegmento = true;
    }

    private criarNovoTipoSegmento(): TipoSegmento {
        const tipoSegmentoNovo = new TipoSegmento();
        tipoSegmentoNovo.nomeTipoSegmento = "";
        tipoSegmentoNovo.siglaTipoSegmento = "";
        
        const estilo = new EstiloSegmento();
        estilo.atributos = [];
        tipoSegmentoNovo.estiloSegmento = estilo;
        return tipoSegmentoNovo
    }

    salvarTipoSegmento(estiloSegmento: EstiloSegmento | null) {
        if (estiloSegmento == null) {
            this.exibirModalEstiloSegmento = false;
            return;
        }
        if (!this.tipoSegmento.nomeTipoSegmento || !this.tipoSegmento.siglaTipoSegmento) {
            if (!this.tipoSegmento.siglaTipoSegmento) {
                setTimeout(() => this.siglaInput.nativeElement.focus(), 1);
                setTimeout(() => this.siglaInput.nativeElement.blur(), 2);
            }
            if (!this.tipoSegmento.nomeTipoSegmento) {
                setTimeout(() => this.nomeInput.nativeElement.focus(), 3);
                setTimeout(() => this.nomeInput.nativeElement.blur(), 4);
            }
            return;
        }

        this.tipoSegmento.estiloSegmento = estiloSegmento;
        if (this.tipoEdicao == INCLUSAO_TIPO_SEGMENTO) {
            this.criar(this.tipoSegmento);
        } else if (this.tipoEdicao == EDICAO_TIPO_SEGMENTO) {
            this.editar(this.tipoSegmento);
        }
    }

    private criar(tipoSegmento: TipoSegmento) {
        this.loadingService.show();
        this.tipoSegmentoService.create(tipoSegmento).subscribe({
            next: () => {
                // this.loadingService.hide();
                this.alertMessageService.info('Sucesso', 'Tipo de segmento incluído com sucesso.');
                this.exibirModalEstiloSegmento = false;
                this.carregarTiposSegmento();
            },
            error: () => this.loadingService.hide()
        });
    }

    private editar(tipoSegmento: TipoSegmento) {
        this.loadingService.show();
        this.tipoSegmentoService.update(tipoSegmento.idTipoSegmento, tipoSegmento).subscribe({
            next: () => {
                // this.loadingService.hide();
                this.alertMessageService.info('Sucesso', 'Tipo de segmento alterado com sucesso.');
                this.exibirModalEstiloSegmento = false;
                this.carregarTiposSegmento();
            },
            error: () => this.loadingService.hide()
        });
    }
}